import { render, staticRenderFns } from "./CoaDetail.vue?vue&type=template&id=0955ce0a&"
import script from "./CoaDetail.vue?vue&type=script&lang=js&"
export * from "./CoaDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoaDetail.vue?vue&type=style&index=0&id=0955ce0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports